// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen'

import { AuthInterceptor } from '@/features/oidc/auth-interceptor'

if (!import.meta.env.STORYBOOK && import.meta.env.MODE !== 'test') {
  client.interceptors.request.use(AuthInterceptor)
}
